import { C } from "@/brand/tokens";

/**
 * FocusAreas6 — compact, keyword-led sub-service list.
 * Two columns on desktop, one on mobile; hairline dividers; no icons.
 */
export function FocusAreas6({ items, tone = "light", label = "Focus areas", testId, className = "" }) {
  const dark = tone === "dark";
  return (
    <div className={className} data-testid={testId}>
      <p
        className="font-inter text-[10px] uppercase font-semibold mb-2"
        style={{ color: C.accentMetal, letterSpacing: "0.26em" }}
      >
        {label}
      </p>
      <ul className="grid sm:grid-cols-2 gap-x-8">
        {items.map((t) => (
          <li
            key={t}
            className="font-inter text-[13px] py-2.5"
            style={{
              color: dark ? C.whiteOnDark : C.inkOnLight,
              borderBottom: `1px solid ${dark ? C.brassSoft : C.paperOver}`,
            }}
          >
            {t}
          </li>
        ))}
      </ul>
    </div>
  );
}
